// DOC-DEPS: LLM.md -> docs/ACTIVITY_MOOD_AUTO_RECOGNITION.md -> docs/ACTIVITY_LEXICON.md
//
// Chinese activity lexicon.
// Categorization principles:
// - STRONG_PHRASES: Complete activity phrases (2+ chars), direct match.
// - VERBS: Single-char root verbs, must be paired with an object (ZH_ACTIVITY_OBJECTS) to confirm activity.

import type { ActivityLexicon } from './types.js';

export const zhActivityLexicon: ActivityLexicon = {
  strongPhrases: [
    // 日常起居
    '起床', '睡觉', '午睡', '午休', '补觉', '洗漱', '刷牙', '洗澡', '护肤', '化妆',
    '洗头', '洗脸', '洗手', '上厕所', '洗衣服', '晾衣服', '叠衣服', '换床单', '收拾房间', '整理桌面', '打扫卫生', '做家务',
    // 饮食
    '吃饭', '吃早饭', '吃早餐', '吃午饭', '吃晚饭', '做饭', '买菜', '喝咖啡', '喝水', '喝热水', '接水', '倒水', '打水',
    '烧水', '烧开水', '烧饭', '煮饭', '蒸饭', '做菜', '烧菜', '炒菜', '切菜', '备菜', '淘米', '煮面', '下面',
    '洗菜', '择菜', '买米', '买面', '买牛奶', '买面包', '煮粥', '熬粥', '蒸菜', '焯水', '切水果', '削水果',
    '泡面', '冲奶粉', '泡燕麦', '洗锅', '刷锅', '收拾厨房', '清理冰箱', '囤菜', '囤货', '补货',
    '去买菜', '去超市采购', '采购食材', '做家常菜', '做汤',
    '煎蛋', '热饭', '热菜', '煲汤', '炖汤', '做早餐', '做午饭', '做晚饭', '喝茶', '泡牛奶',
    '点外卖', '拿外卖', '买早餐', '买午饭', '买晚饭', '喝奶茶', '泡茶', '泡咖啡', '约饭', '干饭', '野餐',
    // 出行交通
    '出门', '打车', '开车', '骑车', '骑行', '坐地铁', '坐公交', '通勤', '赶路', '加油', '充电', '洗车',
    '停车', '找车位', '等车', '坐高铁', '坐火车', '坐飞机', '赶飞机', '赶高铁',
    // 运动健身
    '运动', '散步', '遛弯', '遛弯儿', '跑步', '跑完步', '打球', '健身', '健身房', '撸铁', '拉伸', '瑜伽', '跳绳', '跳操', '游泳',
    '打羽毛球', '打篮球', '踢足球', '打网球', '打乒乓球', '做操', '骑动感单车', '爬楼梯', '爬山', '徒步', '登山', '露营',
    // 工作学习
    '上班', '工作', '学习', '复习', '预习', '上课', '听课', '背单词', '背课文', '刷题', '做题', '写周报', '做作业',
    '阅读', '读书', '读文献', '读杂志', '看教材', '看论文', '阅读文档', '写作', '整理', '收拾', '打扫', '清洁', '开发', 'review',
    // 开会沟通
    '开会', '开组会', '组会', '开站会', '开视频会', '视频会议', '电话会议', '语音会议', '通电话', '接电话', '沟通', '复盘',
    '开晨会', '开例会', '开评审会', '开需求会', '开复盘会',
    // 写作记录
    '写日记', '记日记', '记账', '做笔记', '读报', '看报纸', '看新闻', '刷新闻', '查资料', '查邮件', '回邮件',
    '写计划', '写清单', '写待办', '记待办', '记账单',
    // 社交娱乐
    '聊天', '闲聊', '唠嗑', '连麦', '面基', '约会', '见朋友', '探亲', '串门', '拜访', '聚会', '聚餐',
    '逛街', '探店', 'citywalk', '压马路', '看电影', '看小说', '看动漫', '追番', '追剧', '看展', '看演出', '看直播',
    '刷短视频', '刷视频', '听歌', '听音乐', '听播客', 'k歌', '唱歌', '打游戏', '玩游戏', '开黑', '聚众开黑', '桌游', '打牌',
    // 购物快递
    '买东西', '买咖啡', '买日用品', '买水果', '买菜', '买食材', '买蔬菜', '买肉', '买鸡蛋', '买调料', '买矿泉水', '买瓶装水',
    '逛超市', '逛商场', '逛便利店', '取快递', '拿快递', '寄快递', '收快递', '拆快递',
    // 家务杂事
    '遛狗', '遛猫', '遛娃', '接送娃', '陪娃', '带娃', '接娃', '送娃', '喂猫', '喂狗', '喂鱼', '铲屎', '浇花', '浇菜', '倒垃圾', '洗碗',
    '拖地', '扫地', '擦桌子', '擦玻璃', '晾被子', '收衣服',
    // 医疗健康
    '看医生', '看牙医', '体检', '拿药', '挂号', '复诊',
    // 其他活动
    '摸鱼', '对齐', '上线', '竞品分析', '做汇报', '准备汇报', '做PPT', '发邮件', '回消息', '错题',
    '泡澡', '泡脚', '看手机', '刷手机', '看视频', '到公司', '去洗澡', '去吃饭', '开始学习', '睡醒了', '起夜',
    '看教材', '看论文', '读论文', '写测试', '写用例', '写文章', '写脚本', '写总结', '写文档', '产出',
    '修东西', '修电脑', '修手机', '修车', '打印资料', '复印资料', '扫描文件', '被老板骂', '汇报通过',
    // 查询 / 修改 / 提交 / 认证 / 账号操作
    '查询日志', '查询数据', '查询订单', '查询快递', '检索资料', '搜索文档', '筛选记录', '过滤结果',
    '修改', '改一下', '改了下', '修改配置', '修改参数', '修改信息', '修改资料', '修改订单', '修改文档', '修改方案', '编辑文档', '更新资料', '更正文案',
    '付款', '支付', '付费', '交费', '缴费', '打款', '汇款', '转账', '付账', '结账', '付尾款', '补款', '催款',
    '核对', '核对数据', '核对订单', '核对账单', '核对发票', '对账', '对账单', '校对文档', '校对合同', '复核数据', '复核账单',
    '提交工单', '提交申请', '提交代码', '提交审核',
    '身份认证', '实名认证', '二次验证', '登录账号', '退出登录', '重置密码', '绑定手机号', '解绑设备',
    // 创意爱好（不可分解的复合词；可分解的如 弹琴=弹+琴 由 verb+object 覆盖）
    '绘画', '素描', '写生', '临帖', '速写',
    '拉小提琴', '拉琴',
    '舞蹈', '街舞',
    '书法', '写毛笔字',
    '冥想', '打坐',
    '手工', '插花', '编织', '钩针',
    '摄影', '剪辑', '剪片', '剪视频',
    // 注意：去+地点 由 detectGoToPlaceActivity (movement+place) 覆盖，不在此重复
  ],
  verbs: [
    '吃', '看', '读', '写', '做', '逛', '买', '查', '修', '换', '浇', '收', '撕', '接', '交', '发', '产',
    '练', '背', '学', '听', '刷', '打', '跑', '游', '骑', '遛', '洗', '煮', '炒', '拖', '扫', '聊', '剪', '拍', '记', '复', '付', '核',
    '订', '寄', '拆', '搬', '装', '卸', '摆', '擦', '晾', '叠', '熨', '喂', '铲', '熬', '炖', '烤', '蒸', '冲', '囤', '扔',
    // 创意 / 乐器 / 运动扩充
    '画', '弹', '唱', '跳', '踢', '织', '绣', '折',
    // 日常动作（原 hasShortActionShell 硬编码，统一收归 verbs）
    '喝', '开', '包', '登',
    // 运营/财务/核对高频双字动作
    '修改', '核对', '校对', '复核', '对账', '付款', '支付', '缴费',
  ],
  phrasePatterns: [],
};

/**
 * 独立名词活动词表（ZH 专用）
 *
 * 这些名词单独出现（≤4 字、无动词前缀）时，通常隐含用户正在做该活动：
 * 例如"漫画" → 用户在看漫画，"游戏" → 用户在打游戏。
 * 用于 liveInputClassifier 的短名词活动兜底规则。
 */
export const zhStandaloneActivityNouns: readonly string[] = [
  // 娱乐媒体
  '漫画', '小说', '动漫', '电影', '综艺', '纪录片', '游戏',
  // 乐器
  '钢琴', '吉他', '尤克里里', '小提琴',
  // 棋牌
  '象棋', '围棋', '麻将', '扑克',
];
